<template>
  <div class="sales-reports-overview">
    <SalesReportsTabKpis
      class="mb-4"
      :cards="kpiCards"
    />

    <b-row>
      <b-col
        v-for="card in navCards"
        :key="card.tabKey"
        cols="12"
        md="6"
        lg="4"
        class="mb-3"
      >
        <button
          type="button"
          class="report-nav-card w-100 text-left"
          @click="$emit('navigate', card.tabKey)"
        >
          <i class="fas fa-arrow-right report-nav-card__arrow" />
          <div class="report-nav-card__body">
            <div
              class="report-nav-card__icon"
              :class="`report-nav-card__icon--${card.iconBg}`"
            >
              <i :class="card.icon" />
            </div>
            <div class="report-nav-card__content">
              <h6 class="report-nav-card__title">{{ card.title }}</h6>
              <p class="report-nav-card__desc mb-2">{{ card.description }}</p>
              <code class="report-nav-card__api">{{ card.apiMethod }} {{ card.apiPath }}</code>
            </div>
          </div>
        </button>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { OVERVIEW_NAV_CARDS, getTabByKey } from '../constants';
import SalesReportsTabKpis from './SalesReportsTabKpis.vue';

export default {
  name: 'SalesReportsOverviewPanel',
  components: { SalesReportsTabKpis },
  props: {
    kpiCards: {
      type: Array,
      default: () => [],
    },
    visibleTabKeys: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    navCards() {
      const visible = new Set(this.visibleTabKeys);
      return OVERVIEW_NAV_CARDS.filter((card) => visible.has(card.tabKey)).map(
        (card) => {
          const tab = getTabByKey(card.tabKey);
          return {
            ...card,
            apiPath: tab?.apiPath || `/sales-reports/${card.tabKey}`,
            apiMethod: tab?.apiMethod || 'GET',
          };
        },
      );
    },
  },
};
</script>

<style scoped>
.report-nav-card {
  position: relative;
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  padding: 1rem 1.1rem;
  cursor: pointer;
  transition: border-color 0.15s, box-shadow 0.15s;
}
.report-nav-card:hover {
  border-color: #d1d5db;
  box-shadow: 0 4px 12px rgba(15, 23, 42, 0.06);
}
.report-nav-card:focus {
  outline: none;
  border-color: #93c5fd;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.15);
}
.report-nav-card__arrow {
  position: absolute;
  top: 1rem;
  right: 1rem;
  font-size: 12px;
  color: #9ca3af;
}
.report-nav-card__body {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding-right: 1rem;
}
.report-nav-card__icon {
  flex-shrink: 0;
  width: 40px;
  height: 40px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
}
.report-nav-card__icon--blue {
  background: #eff6ff;
  color: #2563eb;
}
.report-nav-card__icon--indigo {
  background: #eef2ff;
  color: #4f46e5;
}
.report-nav-card__icon--violet {
  background: #f5f3ff;
  color: #7c3aed;
}
.report-nav-card__icon--slate {
  background: #f1f5f9;
  color: #475569;
}
.report-nav-card__icon--teal {
  background: #f0fdfa;
  color: #0d9488;
}
.report-nav-card__icon--orange {
  background: #fff7ed;
  color: #ea580c;
}
.report-nav-card__icon--cyan {
  background: #ecfeff;
  color: #0891b2;
}
.report-nav-card__icon--green {
  background: #ecfdf5;
  color: #16a34a;
}
.report-nav-card__icon--pink {
  background: #fdf2f8;
  color: #db2777;
}
.report-nav-card__icon--amber {
  background: #fffbeb;
  color: #d97706;
}
.report-nav-card__title {
  font-weight: 600;
  color: #111827;
  margin: 0 0 4px;
  font-size: 14px;
}
.report-nav-card__desc {
  font-size: 12px;
  color: #6b7280;
  line-height: 1.45;
  margin: 0;
}
.report-nav-card__api {
  display: inline-block;
  font-size: 10px;
  color: #9ca3af;
  background: transparent;
  padding: 0;
  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
}
</style>
